<template>
  <b-form>
    <b-row>
      <!-- Profile Connections -->
      <b-col
        cols="12"
        class="mt-1"
      >

        <b-row class="text-center">
          <!-- facebook connect button -->
          <b-col
            md="3"
            cols="6"
            class="mb-1"
          >
            <b-card-text class="font-weight-bold d-flex justify-content-center align-items-center mb-2">
              <font-awesome-icon
                icon="fa-brands fa-facebook"
                size="2x"
                :style="{ color: '#0166e1', 'margin-right': '5px' }"
              /> Facebook
            </b-card-text>
            <div
              v-if="socialData.connections.facebook.connected"
              class="mb-1"
            >
              <b-avatar
                size="40"
                :src="socialData.connections.facebook.photoURL"
              />
            </div>
            <template v-if="socialData.connections.facebook.connected">
              <b-card-text class="mb-0">
                {{ socialData.connections.facebook.displayName }}
              </b-card-text>
              <b-card-text class="mb-1">
                @{{ socialData.connections.facebook.id }}
              </b-card-text>

            </template>
            <span
              v-else
              class="text-muted"
            >
              Chưa kết nối
            </span>
          </b-col>
          <!--/ facebook connect button -->

          <!-- google profile -->
          <b-col
            md="3"
            cols="6"
            class="mb-1"
          >
            <b-card-text class="font-weight-bold d-flex justify-content-center align-items-center">
              <font-awesome-icon
                icon="fa-brands fa-google"
                size="2x"
                :style="{ color: '#e63631', 'margin-right': '5px' }"
              /> Google
            </b-card-text>
            <div
              v-if="socialData.connections.google.connected"
              class="mb-1"
            >
              <b-avatar
                size="40"
                :src="socialData.connections.google.photoURL"
              />
            </div>
            <template v-if="socialData.connections.google.connected">
              <b-card-text class="mb-0">
                @{{ socialData.connections.google.displayName }}
              </b-card-text>
              <b-card-text class="mb-0">
                @{{ socialData.connections.google.id }}
              </b-card-text>
            </template>
            <span
              v-else
              class="text-muted"
            >
              Chưa kết nối
            </span>
          </b-col>
          <!--/ google profile -->

        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BInputGroup, BInputGroupPrepend,
  BCardText, BCardImg, BMedia, BAvatar, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';

library.add(faFacebook, faGoogle);
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BInputGroup,
    BInputGroupPrepend,
    BCardText,
    BCardImg,
    BMedia,
    BAvatar,
    BCardText,
    BLink,
    FontAwesomeIcon,
  },
  directives: {
    Ripple,
  },
  props: {
    userId: {
      type: Number,
      default: 0,
    },
    userData: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      socialData: {
        connections: {
          google: {
            photoURL: require('@/assets/images/avatars/default_avatar.jpg'),
            id: 'luraweber',
            connected: 0,
            user: null,
          },
          facebook: {
            photoURL: require('@/assets/images/avatars/default_avatar.jpg'),
            id: 'luraweber',
            connected: 0,
            user: null,
          },
        },
      },
    }
  },
  mounted() {
    const fbUser = this.userData.fb_user ? JSON.parse(this.userData.fb_user) : null;
    const ggUser = this.userData.gg_user ? JSON.parse(this.userData.gg_user) : null;
    if (fbUser) {
      this.socialData.connections.facebook.avatar = fbUser.avatar
      this.socialData.connections.facebook.id = fbUser.uid
      this.socialData.connections.facebook.photoURL = fbUser.photoURL
      this.socialData.connections.facebook.connected = this.userData.fb_connected
      this.socialData.connections.facebook.user = fbUser
      this.socialData.connections.facebook.displayName = fbUser.displayName
    }
    if (ggUser) {
      this.socialData.connections.google.avatar = ggUser.avatar
      this.socialData.connections.google.id = ggUser.uid
      this.socialData.connections.google.photoURL = ggUser.photoURL
      this.socialData.connections.google.connected = this.userData.gg_connected
      this.socialData.connections.google.user = ggUser
      this.socialData.connections.google.displayName = ggUser.displayName
    }
  },
}
</script>

<style></style>
